export const HEADER_PADDING_TOP_PX: number = 100
export const WIDGET_FOOTER_BUTTON_OPACITY: number = 0.3

export const WIDGET_ASSISTANT_AVATARS_MAX_AMOUNT: number = 7
export const WIDGET_ASSISTANT_IFRAME_MOBILE: string = 'widget-assistant-mobile-id'
export const WIDGET_ASSISTANT_IFRAME_DESKTOP: string = 'widget-assistant-desktop-id'
export const WIDGET_ASSISTANT_IFRAME_DESKTOP_INTEGRATION: string = 'widget-assistant-desktop-integration-id'

export const STATS_TABLE_ITEMS_PER_PAGE: number = 10

// z-index
// export const Z_INDEX_MODAL: number = 300
export const Z_INDEX_HEADER: number = 5
// export const Z_INDEX_POPUP: number = 100
